import Nullstack from 'nullstack';
export default function IconBrandWalmart({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-walmart",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 8.04v-5.04"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 10l4.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 14l4.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 15.96v5.04"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 14l-4.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 10l-4.5 -2.505"
  }), " ");
}